"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronUp = function ChevronUp(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M11.563 10.626h2.617L9.09 6 4 10.626h2.617L9.09 8.378z" })
  );
};

exports.default = ChevronUp;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/ChevronUp.js
// module id = 689
// module chunks = 0